import { FetchAuditTypesResponse } from "../../../types/apiResponsesTypes";
import { AuditType } from "../../../types/auditTypes";
import GenericTable from "../GenericTable";
import useTableAuditTypes from "./hooks/useTableAuditTypes";

type Props = {
  data: FetchAuditTypesResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

const TableAuditTypes: React.FC<Props> = ({ data, fetchData, isLoading, onModify, onDelete }) => {
  const { columns, onRowClick } = useTableAuditTypes({ onModify, onDelete });

  return (
    <GenericTable<AuditType>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
    />
  );
};

export default TableAuditTypes;
